import React from "react";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const DealerLocatorGoogleMapElement = React.forwardRef<HTMLDivElement, object>((props, ref) => {
  return (
    <div
      ref={ref}
      css={css`
        .with-search-results & {
          width: calc(100% - var(--box-width));
          margin-left: auto;
        }
        width: 100%;
        height: 70vh;

        background-color: ${CSS_COLORS.Grey0};
      `}
    />
  );
});
